const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export const errorCauseFingerprint = (error: unknown) => {
  if (!isRecord(error) || !isRecord(error.cause)) return undefined;
  const seen = new Set<unknown>([error]);
  let cause = error.cause;
  while (isRecord(cause.cause) && !seen.has(cause.cause)) {
    seen.add(cause);
    cause = cause.cause;
  }
  const name = typeof cause.name === "string" ? cause.name : "";
  const code =
    typeof cause.code === "string" || typeof cause.code === "number" ? cause.code.toString() : "";
  let message = "";
  if (typeof cause.message === "string")
    message = cause.message
      .slice(0, 1000)
      .replace(/\b[\w.+-]+@[\w.-]+\b/g, "<email>")
      .replace(/[0-9a-f]{8}-[0-9a-f-]{20,}/gi, "<id>")
      .replace(/\b[A-Za-z0-9]{20,}\b/g, "<id>")
      .replace(/\b\d{4,}\b/g, "<n>")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 160);
  return `${name}:${code}:${message}`;
};
